exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.info-error-display{position:absolute;top:168px;left:calc(100vw + 200px);background-color:#fff;z-index:26;box-shadow:0 1px 3px 0 rgba(0,0,0,.17);display:flex;border-radius:5px;align-items:center}.info-error-display .message-text{line-height:15px;width:200px;overflow:hidden;font-family:Open Sans,sans-serif;font-weight:600;font-size:11px;color:#353535;padding:8px 8px 8px 0}.info-error-display .message-icon{width:25px;height:23px;margin:8px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/InfoErrorSlider/InfoErrorSlider.scss
// module id = 1571
// module chunks = 0